import * as actions from "./actionTypes";
import * as config from "config";

export function setWithdrawalLimit(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiSetWithdrawalLimit,
            method: "post",
            data: params,
            onStart: actions.SET_WITHDRAWAL_LIMIT_START,
            onSuccess: actions.SET_WITHDRAWAL_LIMIT,
            onError: actions.SET_WITHDRAWAL_LIMIT_FAILED,
            // useLoginJwt: false,
        },
    }
}


// export function resetSetWithdrawalLimit() {
//     return {
//         type: actions.SET_WITHDRAWAL_LIMIT_RESET,
//         payload: {},
//     }
// }
